module.exports = __webpack_public_path__ + "img/logo_login.91031f56.png";